module.exports = __webpack_public_path__ + "newflower.jpg?d967dc1fbb012e5e91ffbab70fb28de0";


//////////////////
// WEBPACK FOOTER
// ./src/images/newflower.jpg
// module id = 325
// module chunks = 0